export default "__VITE_PUBLIC_ASSET__a395e1e1__"